const customSourceKeys = ['newOrderDetailPoller'] as const;

type CustomSourceKey = typeof customSourceKeys[number];

export const isCustomSourceKey = (key: any): key is CustomSourceKey => {
    return customSourceKeys.includes(key);
};

export default CustomSourceKey;
